import React from 'react';
import { Quote } from 'lucide-react';
import { useContent } from '../context/ContentContext';
import Reveal from './Reveal';

const FALLBACK = {
  section_title: 'Das sagen unsere Kunden',
  section_subtitle: '',
  items: [],
};

const Testimonials = () => {
  const data = useContent('testimonials', FALLBACK);

  if (!(data.items || []).length) return null;

  return (
    <section id="testimonials" className="py-24 px-6 bg-white">
      <div className="max-w-[980px] mx-auto">
        <Reveal className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-semibold text-[#1D1D1F] mb-4 tracking-tight" data-testid="testimonials-title">
            {data.section_title}
          </h2>
          {data.section_subtitle && (
            <p className="text-xl text-[#86868B] max-w-2xl mx-auto" data-testid="testimonials-subtitle">
              {data.section_subtitle}
            </p>
          )}
        </Reveal>

        <Reveal delay={100}>
        <div className="grid md:grid-cols-2 gap-6">
          {data.items.map((item, idx) => (
            <div
              key={item.id || idx}
              className="bg-[#F5F5F7] rounded-3xl p-8 flex flex-col"
              data-testid={`testimonial-card-${idx}`}
            >
              <Quote className="w-8 h-8 text-[#0071E3] mb-4" strokeWidth={1.5} />
              <p className="text-lg text-[#1D1D1F] leading-relaxed mb-6 flex-1">
                «{item.quote}»
              </p>
              <div>
                <p className="font-semibold text-[#1D1D1F]">{item.name}</p>
                {item.role && <p className="text-sm text-[#86868B]">{item.role}</p>}
              </div>
            </div>
          ))}
        </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Testimonials;
